// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {isReady} from './isReady'
import {getApiIndex} from './getApiIndex'
import {getServiceProviders} from './getServiceProviders'
import {getGoogleMap} from './getGoogleMap'
import {getCities} from './getCities'
import {getDistricts} from './getDistricts'
import {getSelectedCity} from './getSelectedCity'
import {getDistrictsByCity} from './getDistrictsByCity'
import {getCityByUrl} from './getCityByUrl'
import {getDistrictByUrl} from './getDistrictByUrl'
import {getCityMap} from './getCityMap'
import {getDistrictMap} from './getDistrictMap'

export const mapSelectors = {
  isReady,
  getApiIndex,
  getServiceProviders,
  getGoogleMap,
  getCities,
  getDistricts,
  getSelectedCity,
  getDistrictsByCity,
  getCityByUrl,
  getDistrictByUrl,
  getCityMap,
  getDistrictMap,
}
